import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Comparison } from './components/Comparison';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { Shield, Lock, CreditCard } from 'lucide-react';
export function App() {
  const firstTestimonials = [{
    initials: 'MG',
    quote: 'En 3 días noté la diferencia en el espejo. El diario me mantuvo constante cuando normalmente abandono.',
    name: 'María G.',
    location: 'Córdoba'
  }, {
    initials: 'LP',
    quote: 'El Vacuum por fin lo entendí. Las instrucciones son clarísimas y los resultados se ven rápido.',
    name: 'Laura P.',
    location: 'Rosario'
  }, {
    initials: 'RM',
    quote: 'Nunca pensé que 15 minutos pudieran hacer tanto. Al día 10 la ropa me quedaba diferente.',
    name: 'Roberto M.',
    location: 'Buenos Aires'
  }];
  const secondTestimonials = [{
    initials: 'CR',
    quote: 'El Plan Anti-Sabotaje me cambió la vida. Antes el sábado tiraba todo. Ahora llego al lunes como si nada.',
    name: 'Carla R.',
    location: 'Mendoza'
  }, {
    initials: 'PA',
    quote: 'El Bono de Emergencia lo uso cada vez que me excedo en el asado. En 24 horas vuelvo a estar bien.',
    name: 'Patricia A.',
    location: 'Neuquén'
  }, {
    initials: 'VG',
    quote: 'El Diario de 15 Días es lo que más me ayudó. Soy de las que abandona siempre. Esta vez llegué hasta el final.',
    name: 'Valentina G.',
    location: 'Tucumán'
  }, {
    initials: 'SC',
    quote: 'El Tomo 3 con ingredientes argentinos es oro. Por primera vez seguí un plan sin abandonarlo.',
    name: 'Sofía C.',
    location: 'La Plata'
  }];
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-green/30" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Stats data-id="element-3" />
        <Testimonials testimonials={firstTestimonials} columns={3} data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <Tomos data-id="element-6" />
        <Bonos data-id="element-7" />
        <Countdown data-id="element-8" />
        <Pricing data-id="element-9" />
        <Testimonials title="❤️ MÁS PERSONAS QUE YA LO TIENEN" testimonials={secondTestimonials} columns={2} data-id="element-10" />
        <Guarantee data-id="element-11" />
        <FAQ data-id="element-12" />
        <Comparison data-id="element-13" />

        {/* Final CTA Section */}
        <div className="pt-10 pb-20" data-id="element-14">
          <Pricing title="Empezá hoy. No el próximo lunes." data-id="element-15" />
          <div className="flex flex-col items-center justify-center gap-4 mt-8 text-sm text-gray-400" data-id="element-16">
            <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-17">
              <div className="flex items-center gap-1.5" data-id="element-18">
                <Lock className="w-4 h-4" data-id="element-19" />
                <span data-id="element-20">Pago 100% seguro</span>
              </div>
              <div className="hidden md:block text-gray-600" data-id="element-21">·</div>
              <div className="flex items-center gap-1.5" data-id="element-22">
                <span className="text-brand-gold" data-id="element-23">⚡</span>
                <span data-id="element-24">Acceso en 5 min</span>
              </div>
              <div className="hidden md:block text-gray-600" data-id="element-25">·</div>
              <div className="flex items-center gap-1.5" data-id="element-26">
                <Shield className="w-4 h-4" data-id="element-27" />
                <span data-id="element-28">Garantía 7 días</span>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-29">
              <CreditCard className="w-4 h-4" data-id="element-30" />
              <span data-id="element-31">Mercado Pago · Tarjeta · Transferencia</span>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-32" />
      <PurchaseNotification data-id="element-33" />
    </div>;
}